(function () {
  'use strict';

  const openMapLink = (event) => {
    const destination = encodeURIComponent('Destination');
    const mapLink = event.target.closest('[data-map-link="true"]');

    if (!mapLink) {
      return;
    }

    const latitude = mapLink.dataset.latitude;
    const longitude = mapLink.dataset.longitude;

    if (!latitude || !longitude) {
      return;
    }

    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      // Apple Maps app first
      window.location = `maps://?daddr=${latitude},${longitude}&q=${destination}`;
      // fallback if app not opened
      setTimeout(() => {
        window.open(`https://maps.apple.com/?daddr=${latitude},${longitude}&q=${destination}`, '_blank');
      }, 700);
    } else {
      // Android / desktop
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`, '_blank');
    }
  };

  document.body.addEventListener('click', openMapLink);
}(window));
